import { Loading } from 'components';

const withLoading =
  (Component) =>
  ({ loading, ...props }) =>
    loading ? <Loading /> : <Component {...props} />;

export default withLoading;
